"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Caip10LinkDoctype_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caip10LinkDoctype = exports.DOCTYPE_NAME = void 0;
const common_1 = require("@ceramicnetwork/common");
exports.DOCTYPE_NAME = 'caip10-link';
let Caip10LinkDoctype = Caip10LinkDoctype_1 = class Caip10LinkDoctype extends common_1.Doctype {
    async change(params, opts) {
        const { content, metadata } = params;
        const updateCommit = await Caip10LinkDoctype_1._makeCommit(this, content, metadata === null || metadata === void 0 ? void 0 : metadata.schema);
        const updated = await this.context.api.applyCommit(this.id.toString(), updateCommit, opts);
        this.state = updated.state;
    }
    static async create(params, context, opts) {
        const { content, metadata } = params;
        const commit = await Caip10LinkDoctype_1.makeGenesis({ content, metadata }, context);
        return context.api.createDocumentFromGenesis(exports.DOCTYPE_NAME, commit, opts);
    }
    static async makeGenesis(params, context) {
        const { content, metadata } = params;
        if (content) {
            throw new Error('Account link genesis cannot have content');
        }
        if (!metadata) {
            throw new Error('Metadata must be specified');
        }
        if (!(metadata.controllers && metadata.controllers.length === 1)) {
            throw new Error('Exactly one controller must be specified');
        }
        const [address, linkedChainId] = metadata.controllers[0].split('@');
        if (!linkedChainId) {
            throw new Error('Chain ID must be specified according to CAIP-10');
        }
        return { header: { controllers: metadata.controllers, family: `caip10-${linkedChainId}` } };
    }
    static async _makeCommit(doctype, newContent, newSchema = null) {
        if (newSchema) {
            throw new Error('Schema not allowed on caip10-link doctype');
        }
        if (newContent == null) {
            throw new Error('Proof must be given in doctype');
        }
        return { data: newContent, prev: doctype.tip, id: doctype.state.log[0].cid };
    }
};
Caip10LinkDoctype = Caip10LinkDoctype_1 = __decorate([
    common_1.DoctypeStatic()
], Caip10LinkDoctype);
exports.Caip10LinkDoctype = Caip10LinkDoctype;
//# sourceMappingURL=caip10-link-doctype.js.map